/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PropertySearchRequest from './PropertySearchRequest';
import SearchPagination from './SearchPagination';

/**
 * The PropertySearchEnvelopeRequest model module.
 * @module model/PropertySearchEnvelopeRequest
 * @version 1.0.0
 */
class PropertySearchEnvelopeRequest {
    /**
     * Constructs a new <code>PropertySearchEnvelopeRequest</code>.
     * @alias module:model/PropertySearchEnvelopeRequest
     */
    constructor() { 
        
        PropertySearchEnvelopeRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PropertySearchEnvelopeRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PropertySearchEnvelopeRequest} obj Optional instance to populate.
     * @return {module:model/PropertySearchEnvelopeRequest} The populated <code>PropertySearchEnvelopeRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PropertySearchEnvelopeRequest();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = SearchPagination.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'String');
            }
            if (data.hasOwnProperty('keyword')) {
                obj['keyword'] = ApiClient.convertToType(data['keyword'], 'String');
            }
            if (data.hasOwnProperty('filters')) {
                obj['filters'] = PropertySearchRequest.constructFromObject(data['filters']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PropertySearchEnvelopeRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PropertySearchEnvelopeRequest</code>.
     */
    static validateJSON(data) {
        // validate the optional field `pagination`
        if (data['pagination']) { // data not null
          SearchPagination.validateJSON(data['pagination']);
        }
        // ensure the json data is a string
        if (data['sort'] && !(typeof data['sort'] === 'string' || data['sort'] instanceof String)) {
            throw new Error("Expected the field `sort` to be a primitive type in the JSON string but got " + data['sort']);
        }
        // ensure the json data is a string
        if (data['keyword'] && !(typeof data['keyword'] === 'string' || data['keyword'] instanceof String)) {
            throw new Error("Expected the field `keyword` to be a primitive type in the JSON string but got " + data['keyword']);
        }
        // validate the optional field `filters`
        if (data['filters']) { // data not null
          PropertySearchRequest.validateJSON(data['filters']);
        }

        return true;
    }


}



/**
 * @member {module:model/SearchPagination} pagination
 */
PropertySearchEnvelopeRequest.prototype['pagination'] = undefined;

/**
 * ソート順（任意）
 * @member {String} sort
 */
PropertySearchEnvelopeRequest.prototype['sort'] = undefined;

/**
 * キーワード（住所/最寄駅など）
 * @member {String} keyword
 */
PropertySearchEnvelopeRequest.prototype['keyword'] = undefined;

/**
 * @member {module:model/PropertySearchRequest} filters
 */
PropertySearchEnvelopeRequest.prototype['filters'] = undefined;






export default PropertySearchEnvelopeRequest;

